import {Config} from "../../../__snowpack__/link/packages/config/dist/config.esm.js";
import {createSlice} from "../../../__snowpack__/pkg/@reduxjs/toolkit.js";
import {DEFAULT_THEME} from "../../common/generic-react.styles.js";
export const INITIAL_STATE = {
  name: "Leonardo",
  logo1: "/img/logo_new_one.svg",
  logo2: "/img/logo_public_new_one.svg",
  logo3: "/img/favicon-96x96.png",
  url_config: {
    web_url: window.location.origin,
    api_url: Config.dmEnvironment.host,
    media_url: Config.dmEnvironment.mediaHost
  },
  theme_config: DEFAULT_THEME
};
export const whiteLabelStore = createSlice({
  name: "whiteLabelStore",
  initialState: INITIAL_STATE,
  reducers: {
    setTheme: (state, action) => ({
      ...state,
      theme_config: {
        ...INITIAL_STATE.theme_config,
        ...action.payload
      }
    }),
    resetTheme: (state) => ({
      ...state,
      theme_config: DEFAULT_THEME
    }),
    setConfiguration: (state, action) => ({
      ...state,
      ...action.payload
    }),
    resetConfiguration: () => INITIAL_STATE
  }
});
export default whiteLabelStore.reducer;
